import { jsx as _jsx } from "react/jsx-runtime";
export const QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS = 'quartz-trellis-layout-container';
export const QUARTZ_TRELLIS_BLOCK_START_GLOBAL_SHELL_CLASS = 'quartz-trellis-block-start-global-shell';
export const QUARTZ_TRELLIS_INLINE_START_GLOBAL_SHELL_CLASS = 'quartz-trellis-inline-start-global-shell';
export const QUARTZ_TRELLIS_SHELL_START_SIDE_PANEL_CLASS = 'quartz-trellis-shell-start-side-panel';
export const QUARTZ_TRELLIS_SHELL_END_SIDE_PANEL_CLASS = 'quartz-trellis-shell-end-side-panel';
export const QUARTZ_TRELLIS_MAIN_CLASS = 'quartz-trellis-main';
export const QUARTZ_TRELLIS_MAIN_HEADER_CLASS = 'quartz-trellis-main-header';
export const QUARTZ_TRELLIS_MAIN_START_SIDE_PANEL_CLASS = 'quartz-trellis-main-start-side-panel';
export const QUARTZ_TRELLIS_MAIN_END_SIDE_PANEL_CLASS = 'quartz-trellis-main-end-side-panel';
export const QUARTZ_TRELLIS_MAIN_FOOTER_CLASS = 'quartz-trellis-main-footer';
// NOTE: consumed by quartz-core's client render root to locate the hydration
// container, so this class name must stay stable.
export const QUARTZ_TRELLIS_MAIN_CONTENT_CLASS = 'quartz-trellis-main-content';
export default function TrellisPageLayoutStyles() {
  return /*#__PURE__*/_jsx("style", {
    dangerouslySetInnerHTML: {
      __html: `
      /*
       * Mirrors the Trellis PageLayout component
       * (trellis-components/static/js/components/PageLayout). Values are
       * hard-coded from the Trellis custom-property fallbacks for now; panel
       * open/close state management (toggles, resize, transitions) is
       * intentionally omitted while this is Trellis-internal testing only.
       */

      /* Layout Container (outer grid) */
      .${QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS} {
        background-color: #f0f0f0;
        block-size: calc(100vh - var(--global-nav-height, 0px));
        display: grid;
        grid-template-areas:
          'blockStartGlobalShell blockStartGlobalShell blockStartGlobalShell blockStartGlobalShell'
          'inlineStartGlobalShell startShellSidePanel mainContent endShellSidePanel';
        grid-template-columns: auto auto 1fr auto;
        grid-template-rows: auto 1fr;
        padding-block-start: 16px;
        padding-block-end: 16px;
        padding-inline-start: 16px;
        padding-inline-end: 16px;
      }

      /* The global shells sit flush; their own margins provide the gutter. */
      .${QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS}:has(> .${QUARTZ_TRELLIS_BLOCK_START_GLOBAL_SHELL_CLASS}) {
        padding-block-start: 0px;
      }

      .${QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS}:has(> .${QUARTZ_TRELLIS_INLINE_START_GLOBAL_SHELL_CLASS}) {
        padding-inline-start: 0px;
      }

      /* Block Start Global Shell (top bar, spans all columns) */
      .${QUARTZ_TRELLIS_BLOCK_START_GLOBAL_SHELL_CLASS} {
        grid-area: blockStartGlobalShell;
        margin-block-end: 16px;
      }

      /* Inline Start Global Shell (left rail) */
      .${QUARTZ_TRELLIS_INLINE_START_GLOBAL_SHELL_CLASS} {
        grid-area: inlineStartGlobalShell;
        margin-inline-end: 16px;
        overflow-y: hidden;
      }

      /* Shell Start Side Panel (outer card) */
      .${QUARTZ_TRELLIS_SHELL_START_SIDE_PANEL_CLASS} {
        background-color: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 1px 8px 0px rgba(20, 20, 20, 0.08);
        grid-area: startShellSidePanel;
        inline-size: 320px;
        margin-inline-end: 8px;
        overflow: hidden;
      }

      /* Shell End Side Panel (outer card) */
      .${QUARTZ_TRELLIS_SHELL_END_SIDE_PANEL_CLASS} {
        background-color: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 1px 8px 0px rgba(20, 20, 20, 0.08);
        grid-area: endShellSidePanel;
        inline-size: 320px;
        margin-inline-start: 8px;
        overflow: hidden;
      }

      /* Main (card, nested 3x3 grid).
         Default (non-sticky): the whole card scrolls, so the header scrolls
         away with the content. The [data-sticky] override below pins the
         header/footer and scrolls only the content region. */
      .${QUARTZ_TRELLIS_MAIN_CLASS} {
        background-color: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 1px 8px 0px rgba(20, 20, 20, 0.08);
        display: grid;
        grid-area: mainContent;
        grid-template-columns: auto 1fr auto;
        grid-template-rows: auto minmax(auto, 1fr) auto;
        margin-inline-start: 8px;
        margin-inline-end: 8px;
        overflow-x: hidden;
        overflow-y: auto;
      }

      /* Main Header (row 1). Column span narrows when inset. */
      .${QUARTZ_TRELLIS_MAIN_HEADER_CLASS} {
        grid-row: 1;
        grid-column-start: 1;
        grid-column-end: -1;
        padding-block-start: 24px;
        padding-inline: 24px;
      }

      .${QUARTZ_TRELLIS_MAIN_HEADER_CLASS}[data-inset-left] {
        grid-column-start: 2;
      }

      .${QUARTZ_TRELLIS_MAIN_HEADER_CLASS}[data-inset-right] {
        grid-column-end: -2;
      }

      /* Main Start Side Panel (content-side, inside the card) */
      .${QUARTZ_TRELLIS_MAIN_START_SIDE_PANEL_CLASS} {
        border-inline-end: 1px solid #cccccc;
        grid-column: 1;
        grid-row: 2 / 3;
        inline-size: 240px;
        overflow-y: auto;
      }

      /* Main Content (row 2, column 2 — the app mounts here) */
      .${QUARTZ_TRELLIS_MAIN_CONTENT_CLASS} {
        grid-column: 2;
        grid-row: 2;
        overflow-y: visible;
        padding-block-end: 24px;
        padding-inline: 24px;
      }

      /* sticky: pin the header/footer and scroll only the content region */
      .${QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS}[data-sticky] .${QUARTZ_TRELLIS_MAIN_CLASS} {
        grid-template-rows: auto 1fr auto;
        overflow: hidden;
      }

      .${QUARTZ_TRELLIS_LAYOUT_CONTAINER_CLASS}[data-sticky] .${QUARTZ_TRELLIS_MAIN_CONTENT_CLASS} {
        overflow-y: auto;
      }

      /* Main End Side Panel (content-side, inside the card) */
      .${QUARTZ_TRELLIS_MAIN_END_SIDE_PANEL_CLASS} {
        border-inline-start: 1px solid #cccccc;
        grid-column: 3;
        grid-row: 2 / 3;
        inline-size: 320px;
        overflow-y: auto;
      }

      /* Main Footer (row 3). Column span narrows when inset. Sticky so it
         stays pinned to the bottom while the card scrolls (matches Trellis). */
      .${QUARTZ_TRELLIS_MAIN_FOOTER_CLASS} {
        background-color: #ffffff;
        border-block-start: 1px solid #cccccc;
        grid-row: 3;
        grid-column-start: 1;
        grid-column-end: -1;
        inset-block-end: 0;
        padding-block: 16px;
        padding-inline: 24px;
        position: sticky;
        z-index: 1;
      }

      .${QUARTZ_TRELLIS_MAIN_FOOTER_CLASS}[data-inset] {
        grid-column-start: 2;
        grid-column-end: -2;
      }
    `
    }
  });
}